import { useWorld } from '../hooks/use-world'
import { Overlay, Panel, Title, Buttons, ChoiceButton, DismissButton } from './components/LadderChoiceStyles'

export const LadderChoice = () => {
  const { pendingLadderChoice, setPendingLadderChoice, setCurrentLevel, setPendingSpawn } = useWorld()

  if (!pendingLadderChoice) return null

  const choose = (option) => {
    setPendingLadderChoice(null)
    setPendingSpawn({ x: option.targetX ?? 40, y: option.targetY ?? 40 })
    setCurrentLevel(option.targetLevel ?? 0)
  }

  const sorted = [...pendingLadderChoice].sort((a, b) =>
    (a.direction === 'up' ? -1 : 1) - (b.direction === 'up' ? -1 : 1)
  )

  return (
    <Overlay>
      <Panel>
        <Title>A ladder</Title>
        <Buttons>
          {sorted.map((opt, i) => (
            <ChoiceButton key={i} onClick={() => choose(opt)}>
              {opt.direction === 'up' ? '▲ Go up' : '▼ Go down'}
            </ChoiceButton>
          ))}
        </Buttons>
        <DismissButton onClick={() => setPendingLadderChoice(null)}>
          ignore
        </DismissButton>
      </Panel>
    </Overlay>
  )
}
